// On a phone the toast sits above the fixed bottom bar of the team page, whose
// height changes (the welcome coupon strip adds a row). Pages without the bar
// keep the old 80px.
function mobileBottomOffset() {
  const bar = document.querySelector('[data-mobile-booking-bar]')
  const height = bar ? bar.getBoundingClientRect().height : 0
  return height > 0 ? Math.round(height) + 8 : 80
}

export function showActivityNotifications(toasts) {
  if (!toasts || !toasts.length) return

  const showToast = (icon, msg) => {
    const wrapper = document.createElement('div')
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches
    wrapper.style.cssText = `position:fixed;left:16px;bottom:${isDesktop ? '24px' : `${mobileBottomOffset()}px`};z-index:45;max-width:340px;transition:opacity 0.3s ease,transform 0.3s ease;opacity:0;transform:translateY(20px)`

    const card = document.createElement('div')
    card.style.cssText = 'background:rgba(239,246,255,0.95);border:1px solid #bfdbfe;border-radius:12px;padding:14px 16px;box-shadow:0 8px 24px rgba(0,0,0,0.12);backdrop-filter:blur(8px);display:flex;align-items:center;gap:10px'

    const iconSpan = document.createElement('span')
    iconSpan.style.cssText = 'font-size:20px;flex-shrink:0'
    iconSpan.textContent = icon

    const msgSpan = document.createElement('span')
    msgSpan.style.cssText = 'font-size:14px;font-weight:500;color:#1e40af;overflow:hidden;text-overflow:ellipsis;white-space:nowrap'
    msgSpan.textContent = msg

    card.appendChild(iconSpan)
    card.appendChild(msgSpan)
    wrapper.appendChild(card)
    document.body.appendChild(wrapper)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => { wrapper.style.opacity = '1'; wrapper.style.transform = 'translateY(0)' })
    })
    setTimeout(() => {
      wrapper.style.opacity = '0'
      setTimeout(() => wrapper.remove(), 300)
    }, 5000)
  }

  let cumulative = 0
  toasts.forEach((t) => {
    cumulative += t.delay
    setTimeout(() => showToast(t.icon || '', t.message), cumulative)
  })
}

export function initSocialProofFromDOM() {
  const el = document.getElementById('social-proof-data')
  if (el) {
    try {
      const toasts = JSON.parse(el.dataset.toasts)
      showActivityNotifications(toasts)
    } catch (e) {
      // Silently ignore malformed data
    }
  }
}
